// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".colorscalebar--colormap > div {\n  display: table-cell;\n}\n.colorscalebar--legend {\n  position: relative;\n}\n.colorscalebar--marker {\n  position: absolute;\n}\n.colorscalebar--colormap-bar > svg {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
